import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Icon,
  Text,
  Flex,
} from '@chakra-ui/react'
import { useState } from 'react'
import { FaPhone, FaUser } from 'react-icons/fa'
import {
  MdOutlineMail,
  MdOutlinePhoneIphone,
  MdPhoneInTalk,
} from 'react-icons/md'
import { useModalCallPhone } from '../../../contexts/CallPhoneContext'

export function Telefone({
  email_contato,
  telefone_parceiro,
  nome_cliente,
  celular_parceiro,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Icon
        onClick={onOpen}
        as={FaPhone}
        color="#378BBF"
        fontSize="20px"
        _hover={{
          cursor: 'pointer',
          transform: 'scale(1.1)',
        }}
        transition="all 0.2s"
      />

      <Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl">
        <ModalOverlay />
        <ModalContent>
          <Flex
            position="absolute"
            top="3"
            right="3"
            alignItems="center"
            justifyContent="center"
            fontSize="13px"
            color="#1C2126"
            textTransform={'uppercase'}
            fontWeight="bold"
            onClick={onClose}
            cursor="pointer"
            _hover={{ color: '#378BBF' }}
          >
            <ModalCloseButton
              _focus={{ outline: 'none' }}
              position="relative"
              top="0"
              right="0"
              color="#378BBF"
            />
            Fechar
          </Flex>
          <ModalBody display="flex" flexDir="column" my="75px" gap="20px">
            <Flex alignItems="center" gap={2} px={2} py={2}>
              <Icon as={FaUser} color="#378BBF" fontSize="25px" />
              <Text>
                <Text as="span" fontWeight="semibold">
                  CONTATO:
                </Text>{' '}
                {nome_cliente}
              </Text>
            </Flex>
            <Flex alignItems="center" gap={2} px={2} py={2}>
              <Icon as={MdOutlineMail} color="#378BBF" fontSize="25px" />
              <Text>
                <Text as="span" fontWeight="semibold">
                  EMAIL:
                </Text>{' '}
                {email_contato}
              </Text>
            </Flex>

            <Item
              number={celular_parceiro?.trim()}
              label="TELEFONE"
              icon={MdOutlinePhoneIphone}
            />
            <Item
              number={telefone_parceiro?.trim()}
              label="FIXO"
              icon={MdPhoneInTalk}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

const Item = ({ number, label, icon }) => {
  const [isHovered, setIsHovered] = useState(false)
  const { openCallPhone } = useModalCallPhone()

  return (
    <Flex
      alignItems="center"
      position="relative"
      gap={2}
      cursor="pointer"
      py={2}
      px={2}
      onClick={() => openCallPhone(number)}
      _hover={{
        bgColor: '#378BBF',
        color: 'white!important',
        //svg
        '> svg': {
          color: 'white!important',
        },
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Icon as={icon} color="#378BBF" fontSize="25px" />
      <Text>
        <Text as="span" fontWeight="semibold">
          {label}:
        </Text>{' '}
        {number}
      </Text>

      {!!number && isHovered && (
        <Text
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          color="white"
        >
          Iniciar ligação
        </Text>
      )}
    </Flex>
  )
}
